/*
 * Copyright (c) 2018. Unconventional Software Corporation
 */

import {Component, Input} from '@angular/core';
import {Studio} from "../../models/Studio";

/**
 * Generated class for the StudioItemComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'studio-item-component',
  templateUrl: 'studio-item-component.html'
})
export class StudioItemComponent {

  @Input()
  studio: Studio;

  constructor() {
    console.log('Hello StudioItemComponent Component');
  }

}



// WEBPACK FOOTER //
// ./src/components/studio-item-component/studio-item-component.ts